/**
 * Rejestr podmodułów frontu.
 *
 * Dołożenie komponentu to jeden wpis tutaj i jeden katalog w `modules/` - przeglądarka nadal
 * pobiera jeden plik wejściowy, a treść komponentu dociąga się osobnym chunkiem tylko wtedy,
 * gdy jest potrzebna.
 */
export default [
    {
        name: 'csrf',
        immediate: function (context) {
            return context.data.csrf === '1';
        },
        load: function () {
            return import(/* webpackChunkName: "csrf" */ './modules/csrf');
        }
    },
    {
        name: 'lastViewed',
        immediate: function (context) {
            return context.int('lvProduct') > 0;
        },
        observe: '[data-selly-last-viewed]',
        load: function () {
            return import(/* webpackChunkName: "lastViewed" */ './modules/lastViewed');
        }
    }
];
